import crudActions from '../../crud/actions'

const actions = crudActions('CAREPLAN_SUPPORT_TASKS_')

export default actions
